import {Stack, TextField, Typography} from "@mui/material";
import {useState} from "react";
import {LoadingButton} from "@mui/lab";

interface EnterCodeAuthenticatorComponentProps {
    onClick: (code: string) => void;
    loading: boolean;
    title: string;
    description: string | React.ReactNode;
    buttonText?: string;
}

const EnterCodeAuthenticatorComponent: React.FC<EnterCodeAuthenticatorComponentProps> =
        ({
             onClick,
             loading,
             title,
             description,
             buttonText = "Next"
         }) => {
            const [code, setCode] = useState<string>("");
            return (
                    <Stack
                            spacing={2}
                            justifyContent={'center'}
                            sx={{
                                background: `white`,
                                padding: `32px 26px`,
                                borderRadius: `12px`,
                                boxShadow: `0 4px 6px rgba(0, 0, 0, 0.02),
                    0 10px 24px rgba(0, 0, 0, 0.06),
                    0 0 0 1px rgba(0, 0, 0, 0.02);`}}
            >
                <Typography variant="h4" align={'center'}>
                    {title}
                </Typography>
                <Typography variant="body1" gutterBottom align={"center"}>
                    {description}
                </Typography>

                <TextField
                    fullWidth
                    value={code}
                    onChange={e => setCode(e.target.value)}
                    aria-describedby="outlined-email-helper-text"
                    label={"Code"}
                    variant="outlined"
                    onKeyPress={e => {
                        if (e.code === "Enter") {
                            if (code !== "") {
                                onClick(code);
                            }
                        }
                    }}
                />
                <LoadingButton variant="contained" disabled={code === ""} onClick={() => onClick(code)}
                               loading={loading} size={"large"} loadingPosition="start" startIcon={<></>}
                >
                    {buttonText}
                </LoadingButton>
            </Stack>
        )

    }

export default EnterCodeAuthenticatorComponent